export type ModelFamily = {
  isCustom: boolean;
};
